export const buildDisplayName = (user) => {
    var _a, _b;
    if (((_a = user === null || user === void 0 ? void 0 : user.name) === null || _a === void 0 ? void 0 : _a.first) || ((_b = user === null || user === void 0 ? void 0 : user.name) === null || _b === void 0 ? void 0 : _b.last)) {
        return [user.name.first, user.name.last].join(' ').trim();
    }
    return user === null || user === void 0 ? void 0 : user.alias;
};
//# sourceMappingURL=shared.js.map